import React from 'react';
import Page from '../../layout/Page';
import BirthdayClub from './BirthdayClub';
import RoleProtected, { userRoles } from '../../RoleProtected';

const BirthdayClubPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='Birthday Club' icon='mobile'>
            <BirthdayClub />
        </Page>
    </RoleProtected>
);

export default BirthdayClubPage;
